/**
 * Demandes de camarade REÇUES (migration 0299) : un élève a relevé ton défi
 * SKILLCARD (ou t'a invité) et attend ton accord. Bloc d'action, comme les
 * autres demandes en attente : non configurable, filtré par la recherche,
 * masqué s'il n'y a rien.
 */

import { Check, X } from 'lucide-react';
import { AvatarCircle } from '@/components/avatar-circle';
import { filterByQuery } from '@/lib/contact-search';
import { usePeerRequests, useRespondPeerRequest } from '@/lib/student/peers';

export function PeerRequestsSection({
  studentId,
  filter = '',
}: {
  studentId: string;
  filter?: string;
}) {
  const { data = [] } = usePeerRequests(studentId);
  const respond = useRespondPeerRequest(studentId);
  const shown = filterByQuery(data, filter, (r) => [r.display_name]);
  if (shown.length === 0) return null;

  return (
    <section className="space-y-3" aria-labelledby="peer-requests-title">
      <p
        id="peer-requests-title"
        className="text-ink-400 text-xs font-semibold uppercase tracking-wider"
      >
        Demandes de camarades ({shown.length})
      </p>
      {respond.error && (
        <p className="text-sm text-red-600" role="alert">
          {respond.error.message}
        </p>
      )}
      <ul className="space-y-2">
        {shown.map((r) => (
          <li
            key={r.linkId}
            className="border-primary-200 bg-primary-50 flex items-center gap-3 rounded-2xl border p-3"
          >
            <AvatarCircle name={r.display_name} src={r.avatar_url} size="sm" />
            <div className="min-w-0 flex-1">
              <p className="text-ink-900 truncate text-sm font-semibold">{r.display_name}</p>
              <p className="text-ink-500 mt-0.5 text-xs">veut devenir ton camarade</p>
            </div>
            <div className="flex shrink-0 items-center gap-2">
              <button
                type="button"
                aria-label={`Refuser la demande de ${r.display_name}`}
                disabled={respond.isPending}
                onClick={() => respond.mutate({ linkId: r.linkId, accept: false })}
                className="border-ink-200 text-ink-600 flex h-11 w-11 items-center justify-center rounded-full border bg-white active:scale-[0.98] disabled:opacity-50"
              >
                <X className="h-4 w-4" aria-hidden />
              </button>
              <button
                type="button"
                aria-label={`Accepter la demande de ${r.display_name}`}
                disabled={respond.isPending}
                onClick={() => respond.mutate({ linkId: r.linkId, accept: true })}
                className="bg-primary-600 flex h-11 w-11 items-center justify-center rounded-full text-white active:scale-[0.98] disabled:opacity-50"
              >
                <Check className="h-4 w-4" aria-hidden />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
